import { getFile } from '../storage';

const LINK_REGEX = /<link[^>]*rel="stylesheet"[^>]*href="([^"]*\.css)"[^>]*>/gi;

// A literal </style> in the CSS would close the inlined tag; to CSS, \/ is the same /
const escapeStyleEnd = (css) => css.replace(/<\/(style)/gi, '<\\/$1');

function extractCssPath(href) {
  if (href.startsWith('http://') || href.startsWith('https://')) {
    const url = new URL(href);
    return url.pathname;
  }
  return href.startsWith('/') ? href : `/${href}`;
}

export async function inlineCssInHtml(html) {
  let result = html;
  const matches = [...html.matchAll(LINK_REGEX)];

  for (const match of matches) {
    const cssHref = match[1];
    const cssPath = extractCssPath(cssHref);
    const cssContent = await getFile(cssPath);

    if (cssContent) {
      result = result.replace(
        match[0],
        () => `<style data-original-href="${cssPath}">${escapeStyleEnd(cssContent)}</style>`
      );
    }
  }

  return result;
}

export function restoreCssLinks(html) {
  return html.replace(
    /<style data-original-href="([^"]+)">[\s\S]*?<\/style>/gi,
    (_, href) => `<link rel="stylesheet" href="${href.replace(/^\//, '')}">`
  );
}

export function updateInlinedCss(iframeDoc, cssPath, cssContent) {
  const normalizedPath = cssPath.startsWith('/') ? cssPath : `/${cssPath}`;
  const styleTag = iframeDoc.querySelector(`style[data-original-href="${normalizedPath}"]`);

  if (styleTag) {
    styleTag.textContent = escapeStyleEnd(cssContent);
    return true;
  }
  return false;
}
